import './Hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Excellence in Legal Service Delivery</h1>
        <p>ADVOCATES | NOTARIES PUBLIC | COMMISSIONERS FOR OATH</p>
       <Link to="/contact"><button className="cta-button">Reach Out</button></Link>
      </div>
    </section>
  );
};

export default Hero;